<template>
  <div>
    <v-container>
      <v-row justify="center">
        <h1>Connectivity</h1>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center">
        <p>API keys and connection settings to your trading accounts</p>
      </v-row>
    </v-container>

    <h2>Trading Platform API keys</h2>

    <v-dialog v-model="createSierraChartKey" max-width="400px">
      <template v-slot:activator="{ on }">
        <div class="record-card mt-2" v-on="on">
          <div class="tag">Sierra Chart</div>
          <div class="tag-value float-left mt-2">
            <div class="logodiv pl-4 pt-2">
              <img
                :src="require('@/assets/img/SierraChartLogo.png')"
                height="40"
                style="background-color:white"
              />
            </div>
          </div>
          <div class="float-right">
            <div class="float-right mt-4">
              <v-icon color="#b6c1cb">{{actionSierraChart}}</v-icon>
            </div>
          </div>
        </div>
      </template>
      <createSierraChartKey @close="closeModal" />
    </v-dialog>

    <v-dialog v-model="addOandaKey" max-width="400px">
      <template v-slot:activator="{ on }">
        <div class="record-card mt-2" v-on="on">
          <div class="tag">Oanda (broker)</div>
          <div class="tag-value float-left mt-2">
            <div class="logodiv pt-4">
              <img
                :src="require('@/assets/img/OandaLogo.png')"
                height="25"
                style="background-color:white"
              />
            </div>
          </div>
          <div class="float-right">
            <div class="float-right mt-4">
              <v-icon color="#b6c1cb">{{actionSierraChart}}</v-icon>
            </div>
          </div>
        </div>
      </template>
      <addOandaKey @close="closeModal" />
    </v-dialog>

  </div>
</template>

<script>
import createSierraChartKey from "./createSierraChartKey";
import addOandaKey from "./addOandaKey";
export default {
  name: "PersonalData",
  components: {
    createSierraChartKey,
    addOandaKey
  },
  data() {
    return {
      createSierraChartKey: false,
      addOandaKey: false
    };
  },
  computed: {
    actionSierraChart() {
      if (this.$store.getters.apiSierraChart == null)
        return "add_circle_outline";
      else return "visibility";
    }
  },
  mounted() {},
  methods: {
    closeModal(val) {
      this[val] = false;
    }
  }
};
</script>

<style scoped>

.lowopa{
  opacity: 0.2;
}
.logodiv{
  min-width:100px;
  height:60px;
  background-color:white;
}
h2 {
  color: #4dbac0;
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif !important;
  font-size: 16px;
}
.record-card {
  width: 100%;
  float: left;
  background-color: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  cursor: pointer;
  font-size: 12px;
}

.record-card:hover {
  background: #232a35;
}
.tag {
  color: #b6c1cb;
  text-transform: uppercase;
}
.tag-value {
  font-size: 16px;
}
.avatar {
  border: 10px solid #333b47;
}
.platform {
  float: left;
  margin-left: 15px;
  margin-top: 25px;
}
</style>